(function () {
  if (window.__shaperluvOffer31StickyBound) return;
  window.__shaperluvOffer31StickyBound = true;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  ready(function () {
    function addMobilePolishStylesheet() {
      var stylesheetUrl = 'https://cdn.shopify.com/s/files/1/0763/8643/5419/t/73/assets/shaperluv-offer31-mobile-v1.css?v=1777694473';
      if (document.querySelector('link[href*="shaperluv-offer31-mobile-v1.css"][href*="1777694473"]')) return;

      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = stylesheetUrl;
      document.head.appendChild(link);
    }

    function optimizeFeatureImages() {
      var replacements = [
        ['ezgif.com-optimize_48_0675e509-ee73-4cc2-8793-f23670e79cbd.gif?v=1707475605', 'ezgif.com-optimize_48_0675e509-ee73-4cc2-8793-f23670e79cbd.gif?v=1707475605&width=480'],
        ['brooke-cagle-R0Ea06wC2IM-unsplash_2_461c3101-a9d1-4485-86bf-b03c120f30a8.jpg?v=1702398610', 'brooke-cagle-R0Ea06wC2IM-unsplash_2_461c3101-a9d1-4485-86bf-b03c120f30a8.jpg?v=1702398610&width=720'],
        ['m-brauer-rhnv9fssQwU-unsplash_2_fd19c3b6-61a1-4c31-9af7-0308c7f1061e.jpg?v=1707059806', 'm-brauer-rhnv9fssQwU-unsplash_2_fd19c3b6-61a1-4c31-9af7-0308c7f1061e.jpg?v=1707059806&width=720'],
        ['slv-5.jpg?v=1701930781', 'slv-5.jpg?v=1701930781&width=720'],
        ['jakob-owens-lkMJcGDZLVs-unsplash_2.jpg?v=1702401107', 'jakob-owens-lkMJcGDZLVs-unsplash_2.jpg?v=1702401107&width=720']
      ];

      document.querySelectorAll('img.bri').forEach(function (image) {
        if (!image.src.includes('&width=')) {
          replacements.some(function (pair) {
            if (!image.src.includes(pair[0])) return false;
            image.src = image.src.replace(pair[0], pair[1]);
            return true;
          });
        }

        image.setAttribute('loading', 'lazy');
        image.setAttribute('decoding', 'async');
      });
    }

    addMobilePolishStylesheet();
    optimizeFeatureImages();
    placeDesktopProductCta();

    var stickyButton = document.querySelector('a[href="#image-to-scroll-to"] .buy_now');
    if (!stickyButton) return;

    var stickyLink = stickyButton.closest('a');
    var target = document.getElementById('image-to-scroll-to');
    var productLayout = document.querySelector('[id$="__featured_product_LhYECL"]');
    var productHeader = productLayout ? productLayout.querySelector('.section__header') : null;
    var trigger = target || productLayout;
    if (!trigger) return;

    var style = document.createElement('style');
    style.textContent = [
      '.slv-offer31-sticky-cta { transition: opacity 160ms ease, visibility 160ms ease, transform 160ms ease; }',
      '.slv-offer31-sticky-cta.is-hidden { opacity: 0 !important; pointer-events: none !important; visibility: hidden !important; transform: translateX(-50%) translateY(14px) !important; }',
      '.slv-offer31-sticky-link.is-hidden { pointer-events: none !important; }'
    ].join('\n');
    document.head.appendChild(style);

    stickyButton.classList.add('slv-offer31-sticky-cta');
    if (stickyLink) stickyLink.classList.add('slv-offer31-sticky-link');

    var ticking = false;
    var clickedSticky = false;

    function triggerTop() {
      var element = getHideTrigger();
      return element.getBoundingClientRect().top + window.pageYOffset;
    }

    function getDestination() {
      return document.getElementById('image-to-scroll-to') || productLayout || trigger;
    }

    function getHideTrigger() {
      return productHeader || productLayout || getDestination();
    }

    function setHidden(hidden) {
      stickyButton.classList.toggle('is-hidden', hidden);
      if (stickyLink) stickyLink.classList.toggle('is-hidden', hidden);
    }

    function update() {
      ticking = false;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var stickyHeight = stickyButton.getBoundingClientRect().height || 52;
      var stickyClearance = stickyHeight + Math.min(150, Math.max(96, window.innerHeight * 0.14));
      var hideAt = triggerTop() - window.innerHeight + stickyClearance;
      setHidden(clickedSticky || scrollTop >= hideAt || window.location.hash === '#image-to-scroll-to');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('hashchange', requestUpdate);

    if (stickyLink) {
      stickyLink.addEventListener('click', function (event) {
        var destination = getDestination();
        clickedSticky = true;
        setHidden(true);
        if (destination) {
          event.preventDefault();
          destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#image-to-scroll-to');
          } else {
            window.location.hash = 'image-to-scroll-to';
          }
        }
        window.setTimeout(update, 500);
      });
    }

    update();
    window.setTimeout(update, 600);

    function placeDesktopProductCta() {
      var sourceSection = document.querySelector('[id$="__rich_text_nfpBqj"]');
      var button = sourceSection ? sourceSection.querySelector('a.button, .button') : null;
      var productInfo = document.querySelector('[id$="__featured_product_LhYECL"] .product__info');
      if (!sourceSection || !button || !productInfo) return;

      var sourceParent = button.parentNode;
      var sourceNextSibling = button.nextSibling;
      var slot = productInfo.querySelector('.slv-offer31-product-cta-slot');
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'slv-offer31-product-cta-slot';
        productInfo.appendChild(slot);
      }

      function updateCtaPlacement() {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;

        if (isDesktop) {
          if (button.parentNode !== slot) slot.appendChild(button);
          sourceSection.classList.add('slv-offer31-source-hidden');
          return;
        }

        if (button.parentNode !== sourceParent) {
          sourceParent.insertBefore(button, sourceNextSibling);
        }
        sourceSection.classList.remove('slv-offer31-source-hidden');
      }

      updateCtaPlacement();
      window.addEventListener('resize', updateCtaPlacement);
    }
  });
})();
